import { useState } from "react";
import axios from "axios";
import AnimatedScroll from "../AnimatedScroll/AnimatedScroll";

function ContactForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Pour empêcher le comportement de soumission par défaut
    setLoading(true);
    setSuccessMessage("");

    try {
      const response = await axios.post(
        "https://devalls-backend-c8b6bf6cdb38.herokuapp.com/send-email",
        formData
      );

      if (response.data.success) {
        setSuccessMessage("Votre message a été envoyé avec succès !");
        setFormData({ name: "", email: "", subject: "", message: "" });
      } else {
        setSuccessMessage("Une erreur s'est produite lors de l'envoi.");
      }
    } catch (error) {
      console.error("Erreur lors de l'envoi du message:", error);
      setSuccessMessage("Une erreur s'est produite lors de l'envoi.");
    }

    setLoading(false); // Réactive le bouton après la fin de la requête
  };

  return (
    <div className="single-contact-box">
      <div className="contact-form">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-sm-6 col-xs-12">
              <div className="form-group">
                <AnimatedScroll>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Nom*"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </AnimatedScroll>
              </div>
            </div>
            <div className="col-sm-6 col-xs-12">
              <div className="form-group">
                <AnimatedScroll>
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Email*"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </AnimatedScroll>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="form-group">
                <AnimatedScroll>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Sujet"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                  />
                </AnimatedScroll>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="form-group">
                <AnimatedScroll>
                  <textarea
                    className="form-control"
                    rows="8"
                    placeholder="Message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </AnimatedScroll>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <AnimatedScroll>
                <div className="single-contact-btn">
                  <button
                    type="submit"
                    className="contact-btn"
                    disabled={loading}
                  >
                    {loading ? "Envoi..." : "Envoyez"}
                  </button>
                </div>
              </AnimatedScroll>
            </div>
          </div>
          {successMessage && (
            <div className="success-message">
              <p className="message-send">{successMessage}</p>
            </div>
          )}
        </form>
      </div>
    </div>
  );
}

export default ContactForm;
